// extracted by mini-css-extract-plugin
export default {"container":"Avatar_container__sMSSF","avatar":"Avatar_avatar__+9p4A","avatarText":"Avatar_avatarText__gqFb5"};